import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=16271921&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16271921')) {
      api.createRecord('16271921', component.options)
    } else {
      api.reload('16271921', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=16271921&", function () {
      api.rerender('16271921', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2s926vMQ3rgmH/JS/comp/FavElement.vue"
export default component.exports